/* 🤖 this file was generated by svg-to-ts */
export const mgcIconMaleFilled: {
  name: 'male-filled';
  data: string;
} = {
  name: 'male-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M14.643 3.069C14.291 3.193 14 3.614 14 4c0 .396.291.808.66.934.166.056.393.066 1.557.066h1.363l-1.765 1.765-1.764 1.764-.356-.238c-2.685-1.798-6.124-1.707-8.715.23-2.055 1.537-3.196 4.133-2.938 6.685.266 2.625 1.823 4.878 4.167 6.028 2.235 1.097 4.958.99 7.091-.278a7.492 7.492 0 0 0 2.458-10.573l-.284-.437 1.763-1.763L19 6.42v1.363c0 1.556.012 1.631.299 1.918a.984.984 0 0 0 1.402 0c.308-.307.299-.215.299-3.201s.009-2.894-.299-3.201c-.308-.308-.213-.299-3.218-.296-2.304.003-2.687.012-2.84.066"/></svg>`
};
